import SimpleModalProps from "@/app/interfaces/props/SImpleModalProps";
import { Modal, Box, Typography, Button } from "@mui/material";

const SimpleModal = ({
  isOpen,
  message,
  onClose,
  title = "",
  confirmButtonText = "OK",
}: SimpleModalProps) => {
  return (
    <Modal open={isOpen} onClose={onClose} sx={{ zIndex: 10000 }}>
      <Box
        sx={{
          position: "absolute" as "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 700,
          maxWidth: "90%",
          backgroundColor: "background.paper",
          boxShadow: 24,
          p: 4,
          textAlign: "center",
          zIndex: 999,
        }}
      >
        <Typography
          variant="h6"
          component="h2"
          sx={{ mb: 2, fontWeight: "bold" }}
        >
          {title}
        </Typography>

        <Typography sx={{ mt: 2, mb: 3 }}>{message}</Typography>
        <Button
          className="darkBlueButtonSolid"
          sx={{ px: 4, py: 1 }}
          onClick={onClose}
        >
          {confirmButtonText}
        </Button>
      </Box>
    </Modal>
  );
};

export default SimpleModal;
